import React, { useState } from "react";

interface SubidResearchToolProps { }

const SubBidReasearchTool: React.FC<SubidResearchToolProps> = () => {
  const [subid, setSubid] = useState<string>("");

  const handleGenerate = () => {
    if (!subid) {
      alert("Please enter a Subid to generate results.");
      return;
    }
    // Logic for processing the Subid goes here
    console.log("Generating results for Subid:", subid);
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg max-w-lg mx-auto" style={{ padding: '30px', height: '80%', width: '60%', boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)' }}>
      <h2 className="text-xl font-bold mb-4" style={{ fontSize: '14px' }}>Subid Research Tool</h2>
      <p className="text-sm mb-4">
        Use this tool to research traffic sources (Subids):
      </p>

      <div className="mb-4">
        <label htmlFor="subidSearch" className="block text-sm font-medium" style={{ fontSize: '12px', marginRight: '5px' }}>
          Subid Search
        </label>
        <input
          type="text"
          style={{ padding: "5px 20px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}
          id="subidSearch"
          className="w-full p-2 border rounded-lg"
          value={subid}
          onChange={(e) => setSubid(e.target.value)}
        />
        <button
          style={{ padding: '3px 10px', backgroundColor: '#81D34A', color: 'white', borderColor: 'transparent', fontSize: '10px' }}
          className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
          onClick={handleGenerate}
        >
          Generate
        </button>
      </div>


    </div>
  );
};

export default SubBidReasearchTool;
